import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const CodeBlock = makeShortcode("CodeBlock");
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "style-presets"
    }}>{`Style Presets`}</h1>
    <p>{`Use style presets to customize the look and feel of your generated images.`}</p>
    <h2 {...{
      "id": "understanding-style-presets"
    }}>{`Understanding style presets`}</h2>
    <p>{`Firefly offers a collection of style presets to use with the `}<a parentName="p" {...{
        "href": "../../api/image_generation/V3/"
      }}>{`Generate Images API`}</a>{` that can give generated images a specific visual style or mood. By indicating these presets in the API request, you have more control, beyond the prompt, to create image variations.`}</p>
    <p>{`Style presets are defined in the `}<inlineCode parentName="p">{`presets`}</inlineCode>{` array in the Generate Images API request. All presets in the array apply to the generated image. To influence the impact of the presets, add or adjust the `}<inlineCode parentName="p">{`strength`}</inlineCode>{` value.`}</p>
    <CodeBlock slots="heading, code" languages="JSON" mdxType="CodeBlock" />
    <p>{`Request parameter for presets`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`// ... API request cURL ...
--data '{
    "prompt": "a puppy dressed as a renaissance artist",
    "numVariations": 4,
    "style": {
        // array of style presets for image variations
        "presets": [   
            "bw", "fantasy", "dramatic_light"
        ],
        "strength": 100
    }
}'
`}</code></pre>
    <h2 {...{
      "id": "style-presets-examples"
    }}>{`Style Presets examples`}</h2>
    <p>{`Here are the style presets available and examples of the images they generate. Use these presets, in snake_case, in the API request.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}></th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/2d5c292f6d15c9e0a0cc789a59533bf1/74e62/Graphic.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/2d5c292f6d15c9e0a0cc789a59533bf1/4cd66/Graphic.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/2d5c292f6d15c9e0a0cc789a59533bf1/4cd66/Graphic.png",
                  "alt": "Graphic",
                  "title": "Graphic",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`graphic`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/73268aa08341a244e9258aa758fbbb38/74e62/Wireframe.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/73268aa08341a244e9258aa758fbbb38/4cd66/Wireframe.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/73268aa08341a244e9258aa758fbbb38/4cd66/Wireframe.png",
                  "alt": "Wireframe",
                  "title": "Wireframe",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`wireframe`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/d8527b16bc45351fdea896a971328873/74e62/Vector_look.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/d8527b16bc45351fdea896a971328873/4cd66/Vector_look.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/d8527b16bc45351fdea896a971328873/4cd66/Vector_look.png",
                  "alt": "Vector look",
                  "title": "Vector look",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`vector_look`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/0e7f37ad0964d79f7e9d74005f356201/74e62/Black_and_white.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/0e7f37ad0964d79f7e9d74005f356201/4cd66/Black_and_white.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/0e7f37ad0964d79f7e9d74005f356201/4cd66/Black_and_white.png",
                  "alt": "Black and white",
                  "title": "Black and white",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`bw`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/41cccbc018945f553316f32a1bee0aa6/74e62/Cool_tone.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/41cccbc018945f553316f32a1bee0aa6/4cd66/Cool_tone.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/41cccbc018945f553316f32a1bee0aa6/4cd66/Cool_tone.png",
                  "alt": "Cool tone",
                  "title": "Cool tone",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`cool_colors`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/1b0beae446fac4eb07033f81673fd4ed/74e62/Golden.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/1b0beae446fac4eb07033f81673fd4ed/4cd66/Golden.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/1b0beae446fac4eb07033f81673fd4ed/4cd66/Golden.png",
                  "alt": "Golden",
                  "title": "Golden",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`golden`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/dd3e51af2c857dcec18d7492048285f2/74e62/Monochromatic.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/dd3e51af2c857dcec18d7492048285f2/4cd66/Monochromatic.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/dd3e51af2c857dcec18d7492048285f2/4cd66/Monochromatic.png",
                  "alt": "Monochromatic",
                  "title": "Monochromatic",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`monochromatic`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/bbdea5cefea62221250778662a244509/74e62/Muted_color.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/bbdea5cefea62221250778662a244509/4cd66/Muted_color.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/bbdea5cefea62221250778662a244509/4cd66/Muted_color.png",
                  "alt": "Muted color",
                  "title": "Muted color",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`muted_color`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/8155e531df636e3579464174eee59322/74e62/Pastel_color.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/8155e531df636e3579464174eee59322/4cd66/Pastel_color.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/8155e531df636e3579464174eee59322/4cd66/Pastel_color.png",
                  "alt": "Pastel color",
                  "title": "Pastel color",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`pastel_color`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/7722e41c4026326de5055722730ea508/74e62/Toned_image.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/7722e41c4026326de5055722730ea508/4cd66/Toned_image.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/7722e41c4026326de5055722730ea508/4cd66/Toned_image.png",
                  "alt": "Toned image",
                  "title": "Toned image",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`toned_image`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/33feb5fe10f2a83610de5e5534cf550a/74e62/Vibrant_colors.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/33feb5fe10f2a83610de5e5534cf550a/4cd66/Vibrant_colors.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/33feb5fe10f2a83610de5e5534cf550a/4cd66/Vibrant_colors.png",
                  "alt": "Vibrant colors",
                  "title": "Vibrant colors",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`vibrant_colors`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/a151fda4fbd7bb9b8a025683857f76ce/74e62/Warm_tone.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/a151fda4fbd7bb9b8a025683857f76ce/4cd66/Warm_tone.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/a151fda4fbd7bb9b8a025683857f76ce/4cd66/Warm_tone.png",
                  "alt": "Warm tone",
                  "title": "Warm tone",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`warm_tone`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/5c68d65355fba337cb345dbd9e6e8a00/74e62/Closeup.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/5c68d65355fba337cb345dbd9e6e8a00/4cd66/Closeup.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/5c68d65355fba337cb345dbd9e6e8a00/4cd66/Closeup.png",
                  "alt": "Closeup",
                  "title": "Closeup",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`closeup`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/3ef09e96215dba3512d685c76726ebdb/74e62/Knolling.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/3ef09e96215dba3512d685c76726ebdb/4cd66/Knolling.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/3ef09e96215dba3512d685c76726ebdb/4cd66/Knolling.png",
                  "alt": "Knolling",
                  "title": "Knolling",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`knolling`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/a2fafa13415a07d4090027ff10cc5f32/74e62/Landscape_photography.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/a2fafa13415a07d4090027ff10cc5f32/4cd66/Landscape_photography.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/a2fafa13415a07d4090027ff10cc5f32/4cd66/Landscape_photography.png",
                  "alt": "Landscape photography",
                  "title": "Landscape photography",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`landscape_photography`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/3a99e64d2ff490d50a06f675ee038f60/74e62/Macrophotography.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/3a99e64d2ff490d50a06f675ee038f60/4cd66/Macrophotography.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/3a99e64d2ff490d50a06f675ee038f60/4cd66/Macrophotography.png",
                  "alt": "Macrophotography",
                  "title": "Macrophotography",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`macrophotography`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/c4699b2bbd56826eba5a77b68754a1f3/74e62/Photographed_through_window.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/c4699b2bbd56826eba5a77b68754a1f3/4cd66/Photographed_through_window.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/c4699b2bbd56826eba5a77b68754a1f3/4cd66/Photographed_through_window.png",
                  "alt": "Photographed through window",
                  "title": "Photographed through window",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`photographed_through_window`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/fb52da7e6abf4e9646ad924d4789a3ff/74e62/Shallow_depth_of_field.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/fb52da7e6abf4e9646ad924d4789a3ff/4cd66/Shallow_depth_of_field.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/fb52da7e6abf4e9646ad924d4789a3ff/4cd66/Shallow_depth_of_field.png",
                  "alt": "Shallow depth of field",
                  "title": "Shallow depth of field",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`shallow_depth_of_field`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/acb42ab783d780bdd0f41ffe38b62e8b/74e62/Shot_from_above.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/acb42ab783d780bdd0f41ffe38b62e8b/4cd66/Shot_from_above.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/acb42ab783d780bdd0f41ffe38b62e8b/4cd66/Shot_from_above.png",
                  "alt": "Shot from above",
                  "title": "Shot from above",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`shot_from_above`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/72ab610b3abce91cff3c1cdf87a376b1/74e62/Shot_from_below.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/72ab610b3abce91cff3c1cdf87a376b1/4cd66/Shot_from_below.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/72ab610b3abce91cff3c1cdf87a376b1/4cd66/Shot_from_below.png",
                  "alt": "Shot from below",
                  "title": "Shot from below",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`shot_from_below`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/6b5f04a9ecb8cc591e141b40ec7e9ef9/74e62/Surface_detail.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/6b5f04a9ecb8cc591e141b40ec7e9ef9/4cd66/Surface_detail.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/6b5f04a9ecb8cc591e141b40ec7e9ef9/4cd66/Surface_detail.png",
                  "alt": "Surface detail",
                  "title": "Surface detail",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`surface_detail`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/a5d61555667056207f413a75dbc7f285/74e62/Wide_angle.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/a5d61555667056207f413a75dbc7f285/4cd66/Wide_angle.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/a5d61555667056207f413a75dbc7f285/4cd66/Wide_angle.png",
                  "alt": "Wide angle",
                  "title": "Wide angle",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`wide_angle`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/f347bc536f3e65845328e1d353682368/74e62/Beautiful.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/f347bc536f3e65845328e1d353682368/4cd66/Beautiful.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/f347bc536f3e65845328e1d353682368/4cd66/Beautiful.png",
                  "alt": "Beautiful",
                  "title": "Beautiful",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`beautiful`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/5279f32cb5a2ad0bb7d71c8a4934a10b/74e62/Bohemian.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/5279f32cb5a2ad0bb7d71c8a4934a10b/4cd66/Bohemian.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/5279f32cb5a2ad0bb7d71c8a4934a10b/4cd66/Bohemian.png",
                  "alt": "Bohemian",
                  "title": "Bohemian",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`bohemian`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/eb0ebac535c99a7be6ddbe8db3283ef0/74e62/Chaotic.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/eb0ebac535c99a7be6ddbe8db3283ef0/4cd66/Chaotic.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/eb0ebac535c99a7be6ddbe8db3283ef0/4cd66/Chaotic.png",
                  "alt": "Chaotic",
                  "title": "Chaotic",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`chaotic`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/b0a30f17c84c4fb2bff60f9a0c618445/74e62/Dais.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/b0a30f17c84c4fb2bff60f9a0c618445/4cd66/Dais.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/b0a30f17c84c4fb2bff60f9a0c618445/4cd66/Dais.png",
                  "alt": "Dais",
                  "title": "Dais",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`dais`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/2eaf22ad8f6bad241b32bce4db77b5f8/74e62/Divine.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/2eaf22ad8f6bad241b32bce4db77b5f8/4cd66/Divine.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/2eaf22ad8f6bad241b32bce4db77b5f8/4cd66/Divine.png",
                  "alt": "Divine",
                  "title": "Divine",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`divine`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/6a0455fbc947b772c69ba34d1ac28d19/74e62/Eclectic.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/6a0455fbc947b772c69ba34d1ac28d19/4cd66/Eclectic.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/6a0455fbc947b772c69ba34d1ac28d19/4cd66/Eclectic.png",
                  "alt": "Eclectic",
                  "title": "Eclectic",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`eclectic`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/aa89008e5e87ffd6afa624858c86b877/74e62/Futuristic.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/aa89008e5e87ffd6afa624858c86b877/4cd66/Futuristic.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/aa89008e5e87ffd6afa624858c86b877/4cd66/Futuristic.png",
                  "alt": "Futuristic",
                  "title": "Futuristic",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`futuristic`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/a402758e603f3f2e664d557e0b282c30/74e62/Kitschy.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/a402758e603f3f2e664d557e0b282c30/4cd66/Kitschy.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/a402758e603f3f2e664d557e0b282c30/4cd66/Kitschy.png",
                  "alt": "Kitschy",
                  "title": "Kitschy",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`kitschy`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/edd036685b2c3d32c8c515b5c8dcd4d8/74e62/Nostalgic.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/edd036685b2c3d32c8c515b5c8dcd4d8/4cd66/Nostalgic.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/edd036685b2c3d32c8c515b5c8dcd4d8/4cd66/Nostalgic.png",
                  "alt": "Nostalgic",
                  "title": "Nostalgic",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`nostalgic`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/5ae3bac3d80fdea9fd66b4ad8f00157b/74e62/Simple.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/5ae3bac3d80fdea9fd66b4ad8f00157b/4cd66/Simple.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/5ae3bac3d80fdea9fd66b4ad8f00157b/4cd66/Simple.png",
                  "alt": "Simple",
                  "title": "Simple",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`simple`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/c003f6f404ed2761255e35a333769624/74e62/Antique_photo.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/c003f6f404ed2761255e35a333769624/4cd66/Antique_photo.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/c003f6f404ed2761255e35a333769624/4cd66/Antique_photo.png",
                  "alt": "Antique photo",
                  "title": "Antique photo",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`antique_photo`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/4e70ee4e8d833c5e35d0dceeec907f2f/74e62/Bioluminescent.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/4e70ee4e8d833c5e35d0dceeec907f2f/4cd66/Bioluminescent.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/4e70ee4e8d833c5e35d0dceeec907f2f/4cd66/Bioluminescent.png",
                  "alt": "Bioluminescent",
                  "title": "Bioluminescent",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`bioluminescent`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/a4d1590b3c4d34133aef133521a8ae74/74e62/Bokeh_effect.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/a4d1590b3c4d34133aef133521a8ae74/4cd66/Bokeh_effect.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/a4d1590b3c4d34133aef133521a8ae74/4cd66/Bokeh_effect.png",
                  "alt": "Bokeh effect",
                  "title": "Bokeh effect",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`bokeh`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/dd0d5b4e84829fac587af1a45fa54a97/74e62/Color_explosion.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/dd0d5b4e84829fac587af1a45fa54a97/4cd66/Color_explosion.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/dd0d5b4e84829fac587af1a45fa54a97/4cd66/Color_explosion.png",
                  "alt": "Color explosion",
                  "title": "Color explosion",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`color_explosion`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/0ce795bbf896bc96d296d78ead9441f9/74e62/Dark.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/0ce795bbf896bc96d296d78ead9441f9/4cd66/Dark.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/0ce795bbf896bc96d296d78ead9441f9/4cd66/Dark.png",
                  "alt": "Dark",
                  "title": "Dark",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`dark`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/19ba8362fa9120df39bac9fff32871c6/74e62/Faded_image.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/19ba8362fa9120df39bac9fff32871c6/4cd66/Faded_image.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/19ba8362fa9120df39bac9fff32871c6/4cd66/Faded_image.png",
                  "alt": "Faded image",
                  "title": "Faded image",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`faded_image`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/ef575a3d24d305146d34418cddbc0aa9/74e62/Fisheye.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/ef575a3d24d305146d34418cddbc0aa9/4cd66/Fisheye.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/ef575a3d24d305146d34418cddbc0aa9/4cd66/Fisheye.png",
                  "alt": "Fisheye",
                  "title": "Fisheye",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`fisheye`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/4811e934d96e3a731e7f1ec0711e7e35/74e62/Gomori_photography.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/4811e934d96e3a731e7f1ec0711e7e35/4cd66/Gomori_photography.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/4811e934d96e3a731e7f1ec0711e7e35/4cd66/Gomori_photography.png",
                  "alt": "Gomori photography",
                  "title": "Gomori photography",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`gomori_photography`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/cf8a43ff90269afc8f90e31baee30fa9/74e62/Grainy_film.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/cf8a43ff90269afc8f90e31baee30fa9/4cd66/Grainy_film.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/cf8a43ff90269afc8f90e31baee30fa9/4cd66/Grainy_film.png",
                  "alt": "Grainy film",
                  "title": "Grainy film",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`grainy_film`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/3aab8e3811d47e03f3f9a8681a785467/74e62/Iridescent.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/3aab8e3811d47e03f3f9a8681a785467/4cd66/Iridescent.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/3aab8e3811d47e03f3f9a8681a785467/4cd66/Iridescent.png",
                  "alt": "Iridescent",
                  "title": "Iridescent",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`iridescent`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/687f9861106f353eb618815e20b6d405/74e62/Isometric.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/687f9861106f353eb618815e20b6d405/4cd66/Isometric.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/687f9861106f353eb618815e20b6d405/4cd66/Isometric.png",
                  "alt": "Isometric",
                  "title": "Isometric",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`isometric`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/4067408b01ac41a54d9a7db34316a294/74e62/Misty.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/4067408b01ac41a54d9a7db34316a294/4cd66/Misty.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/4067408b01ac41a54d9a7db34316a294/4cd66/Misty.png",
                  "alt": "Misty",
                  "title": "Misty",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`misty`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/7bec2caacd20a91731c9709719bbf00f/74e62/Neon.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/7bec2caacd20a91731c9709719bbf00f/4cd66/Neon.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/7bec2caacd20a91731c9709719bbf00f/4cd66/Neon.png",
                  "alt": "Neon",
                  "title": "Neon",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`neon`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/a19ef5b388a9a1b7002dce7e8f470235/74e62/Otherworldly_depiction.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/a19ef5b388a9a1b7002dce7e8f470235/4cd66/Otherworldly_depiction.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/a19ef5b388a9a1b7002dce7e8f470235/4cd66/Otherworldly_depiction.png",
                  "alt": "Otherworldly depiction",
                  "title": "Otherworldly depiction",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`otherworldly_depiction`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/8709fca8c113d9c4f8721390288ffc02/74e62/Ultraviolet.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/8709fca8c113d9c4f8721390288ffc02/4cd66/Ultraviolet.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/8709fca8c113d9c4f8721390288ffc02/4cd66/Ultraviolet.png",
                  "alt": "Ultraviolet",
                  "title": "Ultraviolet",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`ultraviolet`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/2f41e0a10f63a87e8fc78da086bbb98f/74e62/Underwater.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/2f41e0a10f63a87e8fc78da086bbb98f/4cd66/Underwater.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/2f41e0a10f63a87e8fc78da086bbb98f/4cd66/Underwater.png",
                  "alt": "Underwater",
                  "title": "Underwater",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`underwater`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/ea4bb9959d32659331998550b8380b0a/74e62/Backlighting.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/ea4bb9959d32659331998550b8380b0a/4cd66/Backlighting.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/ea4bb9959d32659331998550b8380b0a/4cd66/Backlighting.png",
                  "alt": "Backlighting",
                  "title": "Backlighting",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`backlighting`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/52537a50de118d1312b9c93a448cb3ca/74e62/Dramatic_lighting.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/52537a50de118d1312b9c93a448cb3ca/4cd66/Dramatic_lighting.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/52537a50de118d1312b9c93a448cb3ca/4cd66/Dramatic_lighting.png",
                  "alt": "Dramatic light",
                  "title": "Dramatic light",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`dramatic_light`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/ff9cc85821e7d49905942239f219de93/74e62/Golden_hour.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/ff9cc85821e7d49905942239f219de93/4cd66/Golden_hour.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/ff9cc85821e7d49905942239f219de93/4cd66/Golden_hour.png",
                  "alt": "Golden hour",
                  "title": "Golden hour",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`golden_hour`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/42bfc2754a63597c9911a1a379fd8ad7/74e62/Harsh_light.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/42bfc2754a63597c9911a1a379fd8ad7/4cd66/Harsh_light.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/42bfc2754a63597c9911a1a379fd8ad7/4cd66/Harsh_light.png",
                  "alt": "Harsh light",
                  "title": "Harsh light",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`harsh_light`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/36a5584e718d6cf3648b9f660f370170/74e62/Long_time_exposure.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/36a5584e718d6cf3648b9f660f370170/4cd66/Long_time_exposure.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/36a5584e718d6cf3648b9f660f370170/4cd66/Long_time_exposure.png",
                  "alt": "Long-time exposure",
                  "title": "Long-time exposure",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`long`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/6953e2e0a7b160c498b9858a09f0a971/74e62/Low_lighting.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/6953e2e0a7b160c498b9858a09f0a971/4cd66/Low_lighting.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/6953e2e0a7b160c498b9858a09f0a971/4cd66/Low_lighting.png",
                  "alt": "Low lighting",
                  "title": "Low lighting",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`low_lighting`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/a79ad25e4fbe69a4e660401e5dfee27c/74e62/Multiexposure.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/a79ad25e4fbe69a4e660401e5dfee27c/4cd66/Multiexposure.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/a79ad25e4fbe69a4e660401e5dfee27c/4cd66/Multiexposure.png",
                  "alt": "Multiexposure",
                  "title": "Multiexposure",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`multiexposure`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/f22022572027eb911465cc93db578910/74e62/Studio_light.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/f22022572027eb911465cc93db578910/4cd66/Studio_light.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/f22022572027eb911465cc93db578910/4cd66/Studio_light.png",
                  "alt": "Studio light",
                  "title": "Studio light",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`studio_light`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/624942021b700b4e4a37d0b7725b7ded/74e62/Surreal_lighting.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/624942021b700b4e4a37d0b7725b7ded/4cd66/Surreal_lighting.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/624942021b700b4e4a37d0b7725b7ded/4cd66/Surreal_lighting.png",
                  "alt": "Surreal lighting",
                  "title": "Surreal lighting",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`surreal_lighting`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/dda480331039e32039b327b1b12c6d83/74e62/3d_patterns.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/dda480331039e32039b327b1b12c6d83/4cd66/3d_patterns.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/dda480331039e32039b327b1b12c6d83/4cd66/3d_patterns.png",
                  "alt": "3d patterns",
                  "title": "3d patterns",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`3d_patterns`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/b4b95d93bc45e470ad8eabf8f5d1c494/74e62/Charcoal.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/b4b95d93bc45e470ad8eabf8f5d1c494/4cd66/Charcoal.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/b4b95d93bc45e470ad8eabf8f5d1c494/4cd66/Charcoal.png",
                  "alt": "Charcoal",
                  "title": "Charcoal",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`charcoal`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/e8b09c5a2d4f1f1d0ce8cf517d54124f/74e62/Claymation.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/e8b09c5a2d4f1f1d0ce8cf517d54124f/4cd66/Claymation.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/e8b09c5a2d4f1f1d0ce8cf517d54124f/4cd66/Claymation.png",
                  "alt": "Claymation",
                  "title": "Claymation",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`claymation`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/66aa740a294ff6ef7bbfb9bbf9c9e66b/74e62/Fabric.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/66aa740a294ff6ef7bbfb9bbf9c9e66b/4cd66/Fabric.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/66aa740a294ff6ef7bbfb9bbf9c9e66b/4cd66/Fabric.png",
                  "alt": "Fabric",
                  "title": "Fabric",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`fabric`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/4ee7a50a29ecef1b0fca5fe27ca6da36/74e62/Fur.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/4ee7a50a29ecef1b0fca5fe27ca6da36/4cd66/Fur.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/4ee7a50a29ecef1b0fca5fe27ca6da36/4cd66/Fur.png",
                  "alt": "Fur",
                  "title": "Fur",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`fur`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/40f5a2b52a043f2b8a7ad60e428f29e6/74e62/Guilloche_patterns.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/40f5a2b52a043f2b8a7ad60e428f29e6/4cd66/Guilloche_patterns.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/40f5a2b52a043f2b8a7ad60e428f29e6/4cd66/Guilloche_patterns.png",
                  "alt": "Guilloche patterns",
                  "title": "Guilloche patterns",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`guilloche_patterns`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/4365c9c9578e506e146e48ead2641043/74e62/Layered_paper.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/4365c9c9578e506e146e48ead2641043/4cd66/Layered_paper.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/4365c9c9578e506e146e48ead2641043/4cd66/Layered_paper.png",
                  "alt": "Layered paper",
                  "title": "Layered paper",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`layered_paper`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/253b16b56ddf54caaac409f9ba47a38d/74e62/Marble.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/253b16b56ddf54caaac409f9ba47a38d/4cd66/Marble.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/253b16b56ddf54caaac409f9ba47a38d/4cd66/Marble.png",
                  "alt": "Marble",
                  "title": "Marble",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`marble_sculpture`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/7ae19b41bcfeaf52e7f4cf462321a2e0/74e62/Metal.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/7ae19b41bcfeaf52e7f4cf462321a2e0/4cd66/Metal.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/7ae19b41bcfeaf52e7f4cf462321a2e0/4cd66/Metal.png",
                  "alt": "Metal",
                  "title": "Metal",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`made_of_metal`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/95ed75d56f56ad2aa58f19e86f8d43f2/74e62/Origami.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/95ed75d56f56ad2aa58f19e86f8d43f2/4cd66/Origami.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/95ed75d56f56ad2aa58f19e86f8d43f2/4cd66/Origami.png",
                  "alt": "Origami",
                  "title": "Origami",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`origami`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/0e84630e573562a25d921260015efd90/74e62/Paper_mache.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/0e84630e573562a25d921260015efd90/4cd66/Paper_mache.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/0e84630e573562a25d921260015efd90/4cd66/Paper_mache.png",
                  "alt": "Paper mache",
                  "title": "Paper mache",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`paper_mache`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/0548e81d17f947f857a67e749c24b6ae/74e62/Polka_dot_pattern.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/0548e81d17f947f857a67e749c24b6ae/4cd66/Polka_dot_pattern.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/0548e81d17f947f857a67e749c24b6ae/4cd66/Polka_dot_pattern.png",
                  "alt": "Polka-dot pattern",
                  "title": "Polka-dot pattern",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`polka`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/9a85df5b53ee486d7f72e70a7a1db94c/74e62/Strange_patterns.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/9a85df5b53ee486d7f72e70a7a1db94c/4cd66/Strange_patterns.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/9a85df5b53ee486d7f72e70a7a1db94c/4cd66/Strange_patterns.png",
                  "alt": "Strange patterns",
                  "title": "Strange patterns",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`strange_patterns`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/074d0673c31fb067ad401806d5f17e64/74e62/Wood_carving.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/074d0673c31fb067ad401806d5f17e64/4cd66/Wood_carving.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/074d0673c31fb067ad401806d5f17e64/4cd66/Wood_carving.png",
                  "alt": "Wood carving",
                  "title": "Wood carving",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`wood_carving`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/d0a34a18ffe2f590442c24009cd0f6d6/74e62/Yarn.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/d0a34a18ffe2f590442c24009cd0f6d6/4cd66/Yarn.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/d0a34a18ffe2f590442c24009cd0f6d6/4cd66/Yarn.png",
                  "alt": "Yarn",
                  "title": "Yarn",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`yarn`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/b36a5380b8da7b0d7442acbde61c5bdb/74e62/Art_deco.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/b36a5380b8da7b0d7442acbde61c5bdb/4cd66/Art_deco.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/b36a5380b8da7b0d7442acbde61c5bdb/4cd66/Art_deco.png",
                  "alt": "Art deco",
                  "title": "Art deco",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`art_deco`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/62884f9ce546348a3a6e4498cba4bb2c/74e62/Art_nouveau.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/62884f9ce546348a3a6e4498cba4bb2c/4cd66/Art_nouveau.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/62884f9ce546348a3a6e4498cba4bb2c/4cd66/Art_nouveau.png",
                  "alt": "Art nouveau",
                  "title": "Art nouveau",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`art_nouveau`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/a6105211536aed99f614945aef344fbc/74e62/Baroque.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/a6105211536aed99f614945aef344fbc/4cd66/Baroque.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/a6105211536aed99f614945aef344fbc/4cd66/Baroque.png",
                  "alt": "Baroque",
                  "title": "Baroque",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`baroque`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/8585017627d0c4cdce5b6a23cc6f0a49/74e62/Bauhaus.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/8585017627d0c4cdce5b6a23cc6f0a49/4cd66/Bauhaus.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/8585017627d0c4cdce5b6a23cc6f0a49/4cd66/Bauhaus.png",
                  "alt": "Bauhaus",
                  "title": "Bauhaus",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`bauhaus`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/ca451d97ef0b14e41bb88eb35c1f2ca4/74e62/Constructivism.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/ca451d97ef0b14e41bb88eb35c1f2ca4/4cd66/Constructivism.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/ca451d97ef0b14e41bb88eb35c1f2ca4/4cd66/Constructivism.png",
                  "alt": "Constructivism",
                  "title": "Constructivism",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`constructivism`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/bea4528ebeb9f119faf7f5676fe7ccaf/74e62/Cubism.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/bea4528ebeb9f119faf7f5676fe7ccaf/4cd66/Cubism.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/bea4528ebeb9f119faf7f5676fe7ccaf/4cd66/Cubism.png",
                  "alt": "Cubism",
                  "title": "Cubism",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`cubism`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/b78874e2de1bfde1db858915d23221eb/74e62/Cyberpunk.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/b78874e2de1bfde1db858915d23221eb/4cd66/Cyberpunk.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/b78874e2de1bfde1db858915d23221eb/4cd66/Cyberpunk.png",
                  "alt": "Cyberpunk",
                  "title": "Cyberpunk",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`cyberpunk`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/43e0d1f91b83b074c089d067a029ed95/74e62/Fantasy.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/43e0d1f91b83b074c089d067a029ed95/4cd66/Fantasy.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/43e0d1f91b83b074c089d067a029ed95/4cd66/Fantasy.png",
                  "alt": "Fantasy",
                  "title": "Fantasy",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`fantasy`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/554cf754a5759a0abe06da41c2bffe01/74e62/Fauvism.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/554cf754a5759a0abe06da41c2bffe01/4cd66/Fauvism.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/554cf754a5759a0abe06da41c2bffe01/4cd66/Fauvism.png",
                  "alt": "Fauvism",
                  "title": "Fauvism",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`fauvism`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/663771e6192ef4cd7098ae78bd44e271/74e62/Film_noir.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/663771e6192ef4cd7098ae78bd44e271/4cd66/Film_noir.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/663771e6192ef4cd7098ae78bd44e271/4cd66/Film_noir.png",
                  "alt": "Film noir",
                  "title": "Film noir",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`film_noir`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/2286a10406de0cc655e9afe781dc501c/74e62/Glitch_art.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/2286a10406de0cc655e9afe781dc501c/4cd66/Glitch_art.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/2286a10406de0cc655e9afe781dc501c/4cd66/Glitch_art.png",
                  "alt": "Glitch art",
                  "title": "Glitch art",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`glitch_art`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/f59c170d0c70c2dd8545d358fde52756/74e62/Impressionism.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/f59c170d0c70c2dd8545d358fde52756/4cd66/Impressionism.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/f59c170d0c70c2dd8545d358fde52756/4cd66/Impressionism.png",
                  "alt": "Impressionism",
                  "title": "Impressionism",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`impressionism`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/02c12eaede89d15ff3ae971a4ea15bd2/74e62/Industrial.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/02c12eaede89d15ff3ae971a4ea15bd2/4cd66/Industrial.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/02c12eaede89d15ff3ae971a4ea15bd2/4cd66/Industrial.png",
                  "alt": "Industrial",
                  "title": "Industrial",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`industrialism`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/44cae7c4287dfb18abafbb8e5607267b/74e62/Maximalism.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/44cae7c4287dfb18abafbb8e5607267b/4cd66/Maximalism.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/44cae7c4287dfb18abafbb8e5607267b/4cd66/Maximalism.png",
                  "alt": "Maximalism",
                  "title": "Maximalism",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`maximalism`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/a61d1e1e89a36d613782b677e67f99ee/74e62/Minimalism.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/a61d1e1e89a36d613782b677e67f99ee/4cd66/Minimalism.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/a61d1e1e89a36d613782b677e67f99ee/4cd66/Minimalism.png",
                  "alt": "Minimalism",
                  "title": "Minimalism",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`minimalism`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/573925eac842d28fe4730b018cf38a8b/74e62/Modern_art.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/573925eac842d28fe4730b018cf38a8b/4cd66/Modern_art.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/573925eac842d28fe4730b018cf38a8b/4cd66/Modern_art.png",
                  "alt": "Modern art",
                  "title": "Modern art",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`modern_art`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/1c3f8f899626987f06bb6ac7a853f131/74e62/Modernism.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/1c3f8f899626987f06bb6ac7a853f131/4cd66/Modernism.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/1c3f8f899626987f06bb6ac7a853f131/4cd66/Modernism.png",
                  "alt": "Modernism",
                  "title": "Modernism",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`modernism`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/6bd17e7e7b28d712cc886a4e6d34dbbd/74e62/Neoexpressionism.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/6bd17e7e7b28d712cc886a4e6d34dbbd/4cd66/Neoexpressionism.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/6bd17e7e7b28d712cc886a4e6d34dbbd/4cd66/Neoexpressionism.png",
                  "alt": "Neo-expressionism",
                  "title": "Neo-expressionism",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`neo`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/c41a060ec47693f38e45ed83652bfac8/74e62/Pointillism.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/c41a060ec47693f38e45ed83652bfac8/4cd66/Pointillism.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/c41a060ec47693f38e45ed83652bfac8/4cd66/Pointillism.png",
                  "alt": "Pointillism",
                  "title": "Pointillism",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`pointillism`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/0e03782b0148bfaaaee8fe0f0f102ad4/74e62/Psychedelic.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/0e03782b0148bfaaaee8fe0f0f102ad4/4cd66/Psychedelic.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/0e03782b0148bfaaaee8fe0f0f102ad4/4cd66/Psychedelic.png",
                  "alt": "Psychedelic",
                  "title": "Psychedelic",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`psychedelic`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/2b53a64e6d3f0b45fa6cf0738212ba4c/74e62/Science_fiction.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/2b53a64e6d3f0b45fa6cf0738212ba4c/4cd66/Science_fiction.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/2b53a64e6d3f0b45fa6cf0738212ba4c/4cd66/Science_fiction.png",
                  "alt": "Science fiction",
                  "title": "Science fiction",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`science_fiction`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/f145c6a3e2b6093958611ad13fa34c37/74e62/Steampunk.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/f145c6a3e2b6093958611ad13fa34c37/4cd66/Steampunk.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/f145c6a3e2b6093958611ad13fa34c37/4cd66/Steampunk.png",
                  "alt": "Steampunk",
                  "title": "Steampunk",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`steampunk`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/98c5fd3d0141faeef9100fbdd9ccd120/74e62/Surrealism.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/98c5fd3d0141faeef9100fbdd9ccd120/4cd66/Surrealism.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/98c5fd3d0141faeef9100fbdd9ccd120/4cd66/Surrealism.png",
                  "alt": "Surrealism",
                  "title": "Surrealism",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`surrealism`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/a3da733cefc63bf623a46cd084e741c9/74e62/Synthetism.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/a3da733cefc63bf623a46cd084e741c9/4cd66/Synthetism.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/a3da733cefc63bf623a46cd084e741c9/4cd66/Synthetism.png",
                  "alt": "Synthetism",
                  "title": "Synthetism",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`synthetism`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/281ce61502790592f6cfeb17701aada5/74e62/Synthwave.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/281ce61502790592f6cfeb17701aada5/4cd66/Synthwave.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/281ce61502790592f6cfeb17701aada5/4cd66/Synthwave.png",
                  "alt": "Synthwave",
                  "title": "Synthwave",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`synthwave`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/f81a0362ba1d063e3c19af46cbf7c2eb/74e62/Vaporwave.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/f81a0362ba1d063e3c19af46cbf7c2eb/4cd66/Vaporwave.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/f81a0362ba1d063e3c19af46cbf7c2eb/4cd66/Vaporwave.png",
                  "alt": "Vaporwave",
                  "title": "Vaporwave",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`vaporwave`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/11b0482367d80a52ba1152b1961e315d/74e62/Acrylic_paint.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/11b0482367d80a52ba1152b1961e315d/4cd66/Acrylic_paint.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/11b0482367d80a52ba1152b1961e315d/4cd66/Acrylic_paint.png",
                  "alt": "Acrylic paint",
                  "title": "Acrylic paint",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`acrylic_paint`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/4c20efd350c2286b8d33fc3518940efd/74e62/Bold_lines.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/4c20efd350c2286b8d33fc3518940efd/4cd66/Bold_lines.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/4c20efd350c2286b8d33fc3518940efd/4cd66/Bold_lines.png",
                  "alt": "Bold lines",
                  "title": "Bold lines",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`bold_lines`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/888876ead49290b78bf3e68b11e91193/74e62/Chiaroscuro.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/888876ead49290b78bf3e68b11e91193/4cd66/Chiaroscuro.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/888876ead49290b78bf3e68b11e91193/4cd66/Chiaroscuro.png",
                  "alt": "Chiaroscuro",
                  "title": "Chiaroscuro",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`chiaroscuro`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/5cb30acec54b760574f774f66f4d68a2/74e62/Color_shift_art.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/5cb30acec54b760574f774f66f4d68a2/4cd66/Color_shift_art.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/5cb30acec54b760574f774f66f4d68a2/4cd66/Color_shift_art.png",
                  "alt": "Color shift art",
                  "title": "Color shift art",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`color_shift_art`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/c9e26b84f57e5602d55e4b6a5bb914ca/74e62/Daguerreotype.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/c9e26b84f57e5602d55e4b6a5bb914ca/4cd66/Daguerreotype.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/c9e26b84f57e5602d55e4b6a5bb914ca/4cd66/Daguerreotype.png",
                  "alt": "Daguerreotype",
                  "title": "Daguerreotype",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`daguerreotype`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/60d3c60823209411c53886bf42ef8853/74e62/Digital_fractal.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/60d3c60823209411c53886bf42ef8853/4cd66/Digital_fractal.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/60d3c60823209411c53886bf42ef8853/4cd66/Digital_fractal.png",
                  "alt": "Digital fractal",
                  "title": "Digital fractal",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`digital_fractal`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/aee4c4ea37c5bd2869c9db42339a58f2/74e62/Doodle_drawing.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/aee4c4ea37c5bd2869c9db42339a58f2/4cd66/Doodle_drawing.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/aee4c4ea37c5bd2869c9db42339a58f2/4cd66/Doodle_drawing.png",
                  "alt": "Doodle drawing",
                  "title": "Doodle drawing",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`doodle_drawing`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/bf6068bca3de855e986394ea6630688c/74e62/Double_exposure.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/bf6068bca3de855e986394ea6630688c/4cd66/Double_exposure.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/bf6068bca3de855e986394ea6630688c/4cd66/Double_exposure.png",
                  "alt": "Double exposure",
                  "title": "Double exposure",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`double_exposure_portrait`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/d617453b26630e54f474efb450ecffb7/74e62/Fresco.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/d617453b26630e54f474efb450ecffb7/4cd66/Fresco.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/d617453b26630e54f474efb450ecffb7/4cd66/Fresco.png",
                  "alt": "Fresco",
                  "title": "Fresco",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`fresco`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/214163543ca6d3837eb7a2339ae76840/74e62/Geometric_pen.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/214163543ca6d3837eb7a2339ae76840/4cd66/Geometric_pen.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/214163543ca6d3837eb7a2339ae76840/4cd66/Geometric_pen.png",
                  "alt": "Geometric pen",
                  "title": "Geometric pen",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`geometric_pen`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/d44ed046678e543f546520c14c6c5b42/74e62/Halftone.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/d44ed046678e543f546520c14c6c5b42/4cd66/Halftone.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/d44ed046678e543f546520c14c6c5b42/4cd66/Halftone.png",
                  "alt": "Halftone",
                  "title": "Halftone",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`halftone`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/3b0e110ae603e0bcec56fa15e232958f/74e62/Ink.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/3b0e110ae603e0bcec56fa15e232958f/4cd66/Ink.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/3b0e110ae603e0bcec56fa15e232958f/4cd66/Ink.png",
                  "alt": "Ink",
                  "title": "Ink",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`ink`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/6a244d088d2529878503a9f8f80fb8f4/74e62/Light_painting.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/6a244d088d2529878503a9f8f80fb8f4/4cd66/Light_painting.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/6a244d088d2529878503a9f8f80fb8f4/4cd66/Light_painting.png",
                  "alt": "Light painting",
                  "title": "Light painting",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`light_painting`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/ec33a18870682e01a38d299e8c7a3047/74e62/Line_drawing.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/ec33a18870682e01a38d299e8c7a3047/4cd66/Line_drawing.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/ec33a18870682e01a38d299e8c7a3047/4cd66/Line_drawing.png",
                  "alt": "Line drawing",
                  "title": "Line drawing",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`line_drawing`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/98ae26082d55a861ebda0606416f1912/74e62/Linocut.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/98ae26082d55a861ebda0606416f1912/4cd66/Linocut.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/98ae26082d55a861ebda0606416f1912/4cd66/Linocut.png",
                  "alt": "Linocut",
                  "title": "Linocut",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`linocut`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/4916e5725afe4974d7de9e8ea54dcddb/74e62/Oil_paint.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/4916e5725afe4974d7de9e8ea54dcddb/4cd66/Oil_paint.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/4916e5725afe4974d7de9e8ea54dcddb/4cd66/Oil_paint.png",
                  "alt": "Oil paint",
                  "title": "Oil paint",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`oil_paint`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/717e1449e46b4715d7b41ef4a438191a/74e62/Paint_spattering.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/717e1449e46b4715d7b41ef4a438191a/4cd66/Paint_spattering.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/717e1449e46b4715d7b41ef4a438191a/4cd66/Paint_spattering.png",
                  "alt": "Paint Spattering",
                  "title": "Paint Spattering",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`paint_spattering`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/4403c87c2165103d16c6bd3eb3227cac/74e62/Painting.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/4403c87c2165103d16c6bd3eb3227cac/4cd66/Painting.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/4403c87c2165103d16c6bd3eb3227cac/4cd66/Painting.png",
                  "alt": "Painting",
                  "title": "Painting",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`painting`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/87b52a4bb569a51e9e1239f0581e113a/74e62/Palette_knife.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/87b52a4bb569a51e9e1239f0581e113a/4cd66/Palette_knife.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/87b52a4bb569a51e9e1239f0581e113a/4cd66/Palette_knife.png",
                  "alt": "Palette knife",
                  "title": "Palette knife",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`palette_knife`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/d3638250fffc238c76f1bf1c6bf9337b/74e62/Photo_manipulation.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/d3638250fffc238c76f1bf1c6bf9337b/4cd66/Photo_manipulation.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/d3638250fffc238c76f1bf1c6bf9337b/4cd66/Photo_manipulation.png",
                  "alt": "Photo manipulation",
                  "title": "Photo manipulation",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`photo_manipulation`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/d42ca5889558d0540f7f1d1c2563177d/74e62/Scribble_texture.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/d42ca5889558d0540f7f1d1c2563177d/4cd66/Scribble_texture.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/d42ca5889558d0540f7f1d1c2563177d/4cd66/Scribble_texture.png",
                  "alt": "Scribble texture",
                  "title": "Scribble texture",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`scribble_texture`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/5a2ded49c7741c613bb339cd878da5eb/74e62/Sketch.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/5a2ded49c7741c613bb339cd878da5eb/4cd66/Sketch.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/5a2ded49c7741c613bb339cd878da5eb/4cd66/Sketch.png",
                  "alt": "Sketch",
                  "title": "Sketch",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`sketch`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/e550336752f2bd70f054ae7193120b85/74e62/Splattering.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/e550336752f2bd70f054ae7193120b85/4cd66/Splattering.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/e550336752f2bd70f054ae7193120b85/4cd66/Splattering.png",
                  "alt": "Splattering",
                  "title": "Splattering",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`splattering`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/f000d24f530e2a24fbfa0a280d16248c/74e62/Stippling.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/f000d24f530e2a24fbfa0a280d16248c/4cd66/Stippling.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/f000d24f530e2a24fbfa0a280d16248c/4cd66/Stippling.png",
                  "alt": "Stippling",
                  "title": "Stippling",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`stippling_drawing`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/4f92809e4ff6100997d892210cf781ec/74e62/Watercolor.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/4f92809e4ff6100997d892210cf781ec/4cd66/Watercolor.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/4f92809e4ff6100997d892210cf781ec/4cd66/Watercolor.png",
                  "alt": "Watercolor",
                  "title": "Watercolor",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`watercolor`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/75605e0f8ac05bfca0eb881516ef8f8e/74e62/3d.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/75605e0f8ac05bfca0eb881516ef8f8e/4cd66/3d.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/75605e0f8ac05bfca0eb881516ef8f8e/4cd66/3d.png",
                  "alt": "3d",
                  "title": "3d",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`3d`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/3a1ebccfabbe22a6aa6000edeb1878c7/74e62/Anime.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/3a1ebccfabbe22a6aa6000edeb1878c7/4cd66/Anime.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/3a1ebccfabbe22a6aa6000edeb1878c7/4cd66/Anime.png",
                  "alt": "Anime",
                  "title": "Anime",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`anime`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/277d43dc1b3dee5207b11b7306d275de/74e62/Cartoon.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/277d43dc1b3dee5207b11b7306d275de/4cd66/Cartoon.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/277d43dc1b3dee5207b11b7306d275de/4cd66/Cartoon.png",
                  "alt": "Cartoon",
                  "title": "Cartoon",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`cartoon`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/786cdcf8b333c81b74e3b9cdc850d3d4/74e62/Cinematic.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/786cdcf8b333c81b74e3b9cdc850d3d4/4cd66/Cinematic.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/786cdcf8b333c81b74e3b9cdc850d3d4/4cd66/Cinematic.png",
                  "alt": "Cinematic",
                  "title": "Cinematic",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`cinematic`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/d372624e65091bc8d52e5ecd171dd2ec/74e62/Comic_book.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/d372624e65091bc8d52e5ecd171dd2ec/4cd66/Comic_book.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/d372624e65091bc8d52e5ecd171dd2ec/4cd66/Comic_book.png",
                  "alt": "Comic book",
                  "title": "Comic book",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`comic_book`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/77a10ed71e001c57e9e3cd66556df27d/74e62/Concept_art.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/77a10ed71e001c57e9e3cd66556df27d/4cd66/Concept_art.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/77a10ed71e001c57e9e3cd66556df27d/4cd66/Concept_art.png",
                  "alt": "Concept art",
                  "title": "Concept art",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`concept_art`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/6119af1f2a55fbcd0633a7770e411590/74e62/Cyber_matrix.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/6119af1f2a55fbcd0633a7770e411590/4cd66/Cyber_matrix.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/6119af1f2a55fbcd0633a7770e411590/4cd66/Cyber_matrix.png",
                  "alt": "Cyber matrix",
                  "title": "Cyber matrix",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`cyber_matrix`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/c0759001a0ea01df5030b0abc2526bcd/74e62/Digital_art.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/c0759001a0ea01df5030b0abc2526bcd/4cd66/Digital_art.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/c0759001a0ea01df5030b0abc2526bcd/4cd66/Digital_art.png",
                  "alt": "Digital art",
                  "title": "Digital art",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`digital_art`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/9db91f6e466c50840d486a6b55c1afb6/74e62/Flat_design.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/9db91f6e466c50840d486a6b55c1afb6/4cd66/Flat_design.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/9db91f6e466c50840d486a6b55c1afb6/4cd66/Flat_design.png",
                  "alt": "Flat design",
                  "title": "Flat design",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`flat_design`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/5dd527e7b4a0f79759484e78e5c5f51e/74e62/Geometric.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/5dd527e7b4a0f79759484e78e5c5f51e/4cd66/Geometric.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/5dd527e7b4a0f79759484e78e5c5f51e/4cd66/Geometric.png",
                  "alt": "Geometric",
                  "title": "Geometric",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`geometric`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/052c55bc6349cec2ea87fc6b90ae1928/74e62/Glassmorphism.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/052c55bc6349cec2ea87fc6b90ae1928/4cd66/Glassmorphism.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/052c55bc6349cec2ea87fc6b90ae1928/4cd66/Glassmorphism.png",
                  "alt": "Glassmorphism",
                  "title": "Glassmorphism",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`glassmorphism`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/22b41fdff6c4d1b53b866417f035fde1/74e62/Glitch_graphic.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/22b41fdff6c4d1b53b866417f035fde1/4cd66/Glitch_graphic.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/22b41fdff6c4d1b53b866417f035fde1/4cd66/Glitch_graphic.png",
                  "alt": "Glitch graphic",
                  "title": "Glitch graphic",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`glitch_graphic`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/654d6b76ab7fb97e3738b43f93fe1de4/74e62/Graffiti.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/654d6b76ab7fb97e3738b43f93fe1de4/4cd66/Graffiti.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/654d6b76ab7fb97e3738b43f93fe1de4/4cd66/Graffiti.png",
                  "alt": "Graffiti",
                  "title": "Graffiti",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`graffiti`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/fe548f419420bf74a4a7a96d01b85140/74e62/Hyper_realistic.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/fe548f419420bf74a4a7a96d01b85140/4cd66/Hyper_realistic.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/fe548f419420bf74a4a7a96d01b85140/4cd66/Hyper_realistic.png",
                  "alt": "Hyper realistic",
                  "title": "Hyper realistic",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`hyper_realistic`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/bb56824ccf17adff54e5a0febb46a087/74e62/Interior_design.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/bb56824ccf17adff54e5a0febb46a087/4cd66/Interior_design.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/bb56824ccf17adff54e5a0febb46a087/4cd66/Interior_design.png",
                  "alt": "Interior design",
                  "title": "Interior design",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`interior_design`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/0a2246802527dace1e63a542d76691af/74e62/Line_gradient.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/0a2246802527dace1e63a542d76691af/4cd66/Line_gradient.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/0a2246802527dace1e63a542d76691af/4cd66/Line_gradient.png",
                  "alt": "Line gradient",
                  "title": "Line gradient",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`line_gradient`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/f296a0b267a756727ec7fdf79efb05a6/74e62/Low_poly.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/f296a0b267a756727ec7fdf79efb05a6/4cd66/Low_poly.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/f296a0b267a756727ec7fdf79efb05a6/4cd66/Low_poly.png",
                  "alt": "Low poly",
                  "title": "Low poly",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`low_poly`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/265a1678b50ee590f366397a5b062c05/74e62/Newspaper_collage.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/265a1678b50ee590f366397a5b062c05/4cd66/Newspaper_collage.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/265a1678b50ee590f366397a5b062c05/4cd66/Newspaper_collage.png",
                  "alt": "Newspaper collage",
                  "title": "Newspaper collage",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`newspaper_collage`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/851221d49f841503a8704fe81e56ee67/74e62/Optical_illusion.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/851221d49f841503a8704fe81e56ee67/4cd66/Optical_illusion.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/851221d49f841503a8704fe81e56ee67/4cd66/Optical_illusion.png",
                  "alt": "Optical illusion",
                  "title": "Optical illusion",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`optical_illusion`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/21a487a4fdc71b4f49eb435c02394125/74e62/Pattern_pixel.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/21a487a4fdc71b4f49eb435c02394125/4cd66/Pattern_pixel.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/21a487a4fdc71b4f49eb435c02394125/4cd66/Pattern_pixel.png",
                  "alt": "Pattern pixel",
                  "title": "Pattern pixel",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`pattern_pixel`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/150098bd786cff3390aad009297e8510/74e62/Pixel_art.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/150098bd786cff3390aad009297e8510/4cd66/Pixel_art.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/150098bd786cff3390aad009297e8510/4cd66/Pixel_art.png",
                  "alt": "Pixel art",
                  "title": "Pixel art",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`pixel_art`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/01f613afab2658518ac2fe0e44a21d07/74e62/Pop_art.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/01f613afab2658518ac2fe0e44a21d07/4cd66/Pop_art.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/01f613afab2658518ac2fe0e44a21d07/4cd66/Pop_art.png",
                  "alt": "Pop art",
                  "title": "Pop art",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`pop_art`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/14b2e1668897f4898ca9803d20dc586b/74e62/Product_photo.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/14b2e1668897f4898ca9803d20dc586b/4cd66/Product_photo.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/14b2e1668897f4898ca9803d20dc586b/4cd66/Product_photo.png",
                  "alt": "Product photo",
                  "title": "Product photo",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`product_photo`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/4c30a538c638838337fa5314b996d7f3/74e62/Psychedelic_background.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/4c30a538c638838337fa5314b996d7f3/4cd66/Psychedelic_background.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/4c30a538c638838337fa5314b996d7f3/4cd66/Psychedelic_background.png",
                  "alt": "Psychedelic background",
                  "title": "Psychedelic background",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`psychedelic_background`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/12e55a2fd8a09c6d2b18f110233ac138/74e62/Psychedelic_wonderland.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/12e55a2fd8a09c6d2b18f110233ac138/4cd66/Psychedelic_wonderland.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/12e55a2fd8a09c6d2b18f110233ac138/4cd66/Psychedelic_wonderland.png",
                  "alt": "Psychedelic wonderland",
                  "title": "Psychedelic wonderland",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`psychedelic_wonderland`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/bdafd08e957192bdba207eb922f5378f/74e62/Scandinavian.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/bdafd08e957192bdba207eb922f5378f/4cd66/Scandinavian.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/bdafd08e957192bdba207eb922f5378f/4cd66/Scandinavian.png",
                  "alt": "Scandinavian",
                  "title": "Scandinavian",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`scandinavian`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/d510347cc8109a6e6f4d3222734463ed/74e62/Splash_images.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/d510347cc8109a6e6f4d3222734463ed/4cd66/Splash_images.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/d510347cc8109a6e6f4d3222734463ed/4cd66/Splash_images.png",
                  "alt": "Splash images",
                  "title": "Splash images",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`splash_images`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/a4e5ea206e0df38315922351b62266eb/74e62/Stamp.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/a4e5ea206e0df38315922351b62266eb/4cd66/Stamp.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/a4e5ea206e0df38315922351b62266eb/4cd66/Stamp.png",
                  "alt": "Stamp",
                  "title": "Stamp",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`stamp`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "168px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "100%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/fef84d31844adaf71840acb6f0188870/74e62/Trompe_loeil.webp 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/fef84d31844adaf71840acb6f0188870/4cd66/Trompe_loeil.png 168w"],
                  "sizes": "(max-width: 168px) 100vw, 168px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/fef84d31844adaf71840acb6f0188870/4cd66/Trompe_loeil.png",
                  "alt": "Trompe l'oeil",
                  "title": "Trompe l'oeil",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`trompe_loeil`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "concepts-in-action"
    }}>{`Concepts in action`}</h2>
    <p>{`Let's use style presets to generate a few image variations.`}</p>
    <InlineAlert variant="warning" slots="header, text" mdxType="InlineAlert" />
    <p>{`Before you start`}</p>
    <p>{`You'll need a Firefly `}<strong parentName="p">{`Client ID`}</strong>{` and `}<strong parentName="p">{`Access Token`}</strong>{` for this exercise. Learn how to retrieve them in the `}<a parentName="p" {...{
        "href": "../authentication/index.md"
      }}>{`Authentication Guide`}</a>{`. `}<strong parentName="p">{`Securely store these credentials and never expose them in client-side or public code.`}</strong></p>
    <ol>
      <li parentName="ol">{`First, open a secure terminal and `}<inlineCode parentName="li">{`export`}</inlineCode>{` your `}<strong parentName="li">{`Client ID`}</strong>{` and `}<strong parentName="li">{`Access Token`}</strong>{` as environment variables:`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`export FIREFLY_SERVICES_CLIENT_ID=<your_Client_ID>
export FIREFLY_SERVICES_ACCESS_TOKEN=<your_Access_Token>
`}</code></pre>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Next, make the request to the Generate Images API. We'll use a prompt for a Shakespearean puppy, and enter a few presets so that they apply together:`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`curl --location 'https://firefly-api.adobe.io/v3/images/generate-async' \\
--header 'Content-Type: application/json' \\
--header 'Accept: application/json' \\
--header "x-api-key: $FIREFLY_SERVICES_CLIENT_ID" \\
--header "Authorization: Bearer $FIREFLY_SERVICES_ACCESS_TOKEN" \\
--data '{
    "prompt": "a puppy dressed as a renaissance artist",
    "numVariations": 4,
    "style": {
        "presets": [
            "bw", "fantasy", "dramatic_light"
        ]
    }
}'
`}</code></pre>
    <p>{`The request returns a rapid response for the asynchronous job:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{   
    "jobId":"<YOUR_JOB_ID>",
    "statusUrl":"https://firefly-epo854211.adobe.io/v3/status/urn:ff:jobs:...",
    "cancelUrl":"https://firefly-epo854211.adobe.io/v3/cancel/urn:ff:jobs:..."
}
`}</code></pre>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Use the `}<inlineCode parentName="li">{`jobId`}</inlineCode>{` to see the result:`}</li>
    </ol>
    <InlineAlert variant="info" slots="header, text" mdxType="InlineAlert" />
    <p>{`NOTE`}</p>
    <p>{`The `}<inlineCode parentName="p">{`numVariations`}</inlineCode>{` value creates four generated images that will be easy to compare. Four URLs are returned in the response.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`curl -X GET "https://firefly-api.adobe.io/v3/status/<YOUR_JOB_ID>" \\
    -H "x-api-key: $FIREFLY_SERVICES_CLIENT_ID" \\
    -H "Authorization: Bearer $FIREFLY_SERVICES_ACCESS_TOKEN" \\
    -H "Content-Type: application/json"
`}</code></pre>
    <p>{`You'll see results similar to our example below. Notice that all the defined presets were applied to the prompt for a renaissance puppy!`}</p>
    <p><strong parentName="p">{`Sample Result`}</strong></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "57.1875%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/firefly-services/docs/static/e295e572584fa15236474041c00d7740/5530d/puppy-renaissance-artist.webp 320w", "/firefly-services/docs/static/e295e572584fa15236474041c00d7740/0c8fb/puppy-renaissance-artist.webp 640w", "/firefly-services/docs/static/e295e572584fa15236474041c00d7740/94b1e/puppy-renaissance-artist.webp 1280w", "/firefly-services/docs/static/e295e572584fa15236474041c00d7740/0b34d/puppy-renaissance-artist.webp 1920w", "/firefly-services/docs/static/e295e572584fa15236474041c00d7740/d5269/puppy-renaissance-artist.webp 2560w", "/firefly-services/docs/static/e295e572584fa15236474041c00d7740/99ebf/puppy-renaissance-artist.webp 2688w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/firefly-services/docs/static/e295e572584fa15236474041c00d7740/8980b/puppy-renaissance-artist.jpg 320w", "/firefly-services/docs/static/e295e572584fa15236474041c00d7740/56d4e/puppy-renaissance-artist.jpg 640w", "/firefly-services/docs/static/e295e572584fa15236474041c00d7740/62aaf/puppy-renaissance-artist.jpg 1280w", "/firefly-services/docs/static/e295e572584fa15236474041c00d7740/aaf92/puppy-renaissance-artist.jpg 1920w", "/firefly-services/docs/static/e295e572584fa15236474041c00d7740/36eba/puppy-renaissance-artist.jpg 2560w", "/firefly-services/docs/static/e295e572584fa15236474041c00d7740/b69c9/puppy-renaissance-artist.jpg 2688w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/firefly-services/docs/static/e295e572584fa15236474041c00d7740/62aaf/puppy-renaissance-artist.jpg",
            "alt": "A renaissance artist puppy generated with presets",
            "title": "A renaissance artist puppy generated with presets",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    {/* links */}

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      